export default function seeds(server) {
  server.createList('campaign', 18)
  server.createList('partner', 64)
  server.create('coin')
  server.createList('award', 50)
}



// WEBPACK FOOTER //
// ./src/mocks/seeds/index.js